// @ts-check

import React from 'react';
import { array, func, object } from 'prop-types';
import USER from '../ts/profileEditorEnum';
import ProfilePaper from './ProfilePaper';
import Grid from '@mui/material/Grid';
import PhoneField from 'components/phoneField/PhoneField';
import ProfileEditorField from './ProfileEditorField';
import LanguageSelector from './LanguageSelector';
import ContactTypeSelector from './ContactTypeSelector';
import RoleGroupSelector from './RoleGroupSelector';
import Typography from '@mui/material/Typography';

/**
 * @component ProfileEditorPersonal
 * @param {Object} props
 * @param {EditorUserType} props.editorUser
 * @param {EditorUserValidType} props.valid
 * @param {LanguageType[]} props.languages
 * @param {ContactType[]} props.contactTypes
 * @param {RoleGroupType[]} props.roleGroups
 * @param {UserInfoType} props.userInfo
 * @param {(name:string, payload: any)=>void} props.onHandle
 * @returns {JSX.Element}
 */
function ProfileEditorPersonal(props) {
	const { editorUser, valid, languages, contactTypes, roleGroups, userInfo, onHandle } = props;

	return (
		<ProfilePaper>
			<Typography variant="button">Personal Infomation</Typography>
			<Grid container spacing={2}>
				<Grid item lg={4} xs={12}>
					<PhoneField
						label="Work Phone"
						name={USER.PHONE_WORK}
						value={`${editorUser.phoneWorkDialCode}${editorUser.phoneWork}${editorUser.phoneWorkExt}`}
						valid={valid[USER.PHONE_WORK]}
						onHandle={onHandle}
					/>
				</Grid>
				<Grid item lg={4} xs={12}>
					<PhoneField
						label="Mobile Phone"
						name={USER.PHONE_MOBILE}
						value={`${editorUser.phoneMobileDialCode}${editorUser.phoneMobile}${editorUser.phoneMobileExt}`}
						valid={valid[USER.PHONE_MOBILE]}
						onHandle={onHandle}
					/>
				</Grid>
				<Grid item lg={4} xs={12}>
					<PhoneField
						label="Other Phone"
						name={USER.PHONE_OTHER}
						value={`${editorUser.phoneOtherDialCode} ${editorUser.phoneOther}${editorUser.phoneOtherExt}`}
						valid={valid[USER.PHONE_OTHER]}
						onHandle={onHandle}
					/>
				</Grid>
			</Grid>
			<Grid container spacing={2}>
				<Grid item lg={4} xs={12}>
					<ProfileEditorField
						name={USER.EMAIL_WORK}
						required={false}
						label="Work Email"
						value={editorUser[USER.EMAIL_WORK]}
						valid={valid[USER.EMAIL_WORK]}
						onHandleUser={onHandle}
					/>
				</Grid>
				<Grid item lg={4} xs={12}>
					<ProfileEditorField
						name={USER.EMAIL_PERSONAL}
						required={false}
						label="Personal Email"
						value={editorUser[USER.EMAIL_PERSONAL]}
						valid={valid[USER.EMAIL_PERSONAL]}
						onHandleUser={onHandle}
					/>
				</Grid>
				<Grid item lg={4} xs={12}>
					<ProfileEditorField
						name={USER.EMAIL_OTHER}
						required={false}
						label="Other Email"
						value={editorUser[USER.EMAIL_OTHER]}
						valid={valid[USER.EMAIL_OTHER]}
						onHandleUser={onHandle}
					/>
				</Grid>
			</Grid>
			<Grid container spacing={2}>
				<Grid item lg={4} xs={12}>
					<LanguageSelector
						values={editorUser[USER.LANGUAGES]}
						options={languages}
						valid={valid[USER.LANGUAGES]}
						onHandleUser={onHandle}
					/>
				</Grid>
				<Grid item lg={4} xs={12}>
					<ContactTypeSelector
						values={editorUser[USER.CONTACT_TYPES]}
						options={contactTypes}
						valid={valid[USER.CONTACT_TYPES]}
						onHandleUser={onHandle}
					/>
				</Grid>
				<Grid item lg={4} xs={12}>
					<RoleGroupSelector
						values={editorUser[USER.ROLE_GROUPS]}
						options={roleGroups}
						valid={valid[USER.ROLE_GROUPS]}
						userInfo={userInfo}
						onHandleUser={onHandle}
					/>
				</Grid>
			</Grid>
		</ProfilePaper>
	);
}

ProfileEditorPersonal.propTypes = {
	editorUser: object,
	valid: object,
	languages: array,
	contactTypes: array,
	roleGroups: array,
	userInfo: object,
	onHandle: func,
};

export default ProfileEditorPersonal;
